import React from "react";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { Total } from "../../../Components/Total";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SeparationState, separationActions } from "../../store";
import { NormalizedCargo } from "../../../../../../domain/models/cargo-model";
import { useParams } from "react-router-dom";
import { CargoCard } from "../CargoCard";
import Stack from "@mui/material/Stack";
import { useDispatch } from "react-redux";

export const CargosOfRoute: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cargos = useSelector<SeparationState, NormalizedCargo[]>(
    (state) => state.cargos
  );

  const route = useSelector<SeparationState, string>(
    (state) => state.currentRoute
  );

  const currentCargos = cargos.filter((cargo) => cargo.route === route);

  return (
    <>
      <DrawerAppBar
        title="Separar Mercadoria"
        onBack={() => {
          navigate("/mobile/separation");
        }}
      />
      <Total text="Cargas" number={"3"} />
      <Stack sx={{ m: "20px" }} spacing={4}>
        {currentCargos.map((cargo) => {
          return (
            <CargoCard
              cargo={cargo}
              onClick={() => {
                dispatch(separationActions.setCurrentCargo({ cargo }));
                navigate("/mobile/separation/items", { replace: false });
              }}
              key={cargo.reference}
            />
          );
        })}
      </Stack>
    </>
  );
};
